"use strict";

exports.__esModule = true;
exports.CreateAlertWatcherRuleScreen = CreateAlertWatcherRuleScreen;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _App = require("../../App");
var _AlertWatcherRuleForm = require("../AlertWatcherRuleForm");
var _System = require("../../../System");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function CreateAlertWatcherRuleScreen(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var defaultDaysOfTheWeek = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("CreateAlertWatcherRuleScreen.title", "Create Watcher Rule")
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("CreateAlertWatcherRuleScreen.navbar.title", "Create Watcher Rule")
  }), /*#__PURE__*/_react["default"].createElement(_AlertWatcherRuleForm.AlertWatcherRuleForm, {
    initialValues: {
      name: "",
      enabled: true,
      tags: [],
      from: "00:00",
      to: "08:00",
      daysOfTheWeek: defaultDaysOfTheWeek,
      types: [],
      devices: [],
      deviceTags: [],
      users: [],
      emails: []
    },
    onSubmit: function onSubmit(_ref) {
      var name = _ref.name,
        enabled = _ref.enabled,
        tags = _ref.tags,
        from = _ref.from,
        to = _ref.to,
        daysOfTheWeek = _ref.daysOfTheWeek,
        devices = _ref.devices,
        deviceTags = _ref.deviceTags,
        users = _ref.users,
        emails = _ref.emails;
      return props.collection.create({
        name: name,
        enabled: enabled,
        tags: tags,
        from: from,
        to: to,
        daysOfTheWeek: daysOfTheWeek,
        devices: devices.map(function (value) {
          return {
            type: "UUID",
            value: value
          };
        }).concat(deviceTags.map(function (value) {
          return {
            type: "TAG",
            value: value
          };
        })),
        watchers: users.map(function (value) {
          return {
            type: "USER",
            value: value
          };
        }).concat(emails.map(function (value) {
          return {
            type: "EMAIL",
            value: value
          };
        }))
      }).then(function () {
        props.onSave();
        props.history.push((0, _System.getScreenLocation)("AlertWatcherRuleList"));
      });
    }
  }));
}